/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const commonModule = require('@utils/common/commonModule');
const cmsModule = require('@utils/cms/cmsModule');
const socialMediaShareButtonDirective = require('./socialMediaShareButtonDirective');

const socialMediaShareButtonModule = angular
    .module('enervee_utils.social_media_share_button', [
        commonModule.name,
        cmsModule.name
    ])
    .directive('socialMediaShareButton', socialMediaShareButtonDirective);

module.exports = socialMediaShareButtonModule;
